import React from 'react';
import moment from 'moment';
import { Grid2 as Grid } from '@mui/material';
import ContentViewComponent from '../../../../Component/ContentViewComponent/ContentViewComponent';
import TableComponent from '../../../../Component/TableComponent/TableComponent';
import ApiHandler from '../../../../Handler/ApiHandler';
import ShadowBoxComponent from '../../../../Component/ShadowBoxComponent/ShadowBoxComponent';
import TitleComponent from '../../../../Component/TitleComponent/TitleComponent';
import { dispatch } from '../../../../App';
import { TableReload } from '../../../../Reducer/TableReducer/TableSlice';
import { initFormHandler } from '../../../../Handler/FormHandler';
import TextFieldComponent from '../../../../Component/TextFieldComponent/TextFieldComponent';
import SelectComponent from '../../../../Component/SelectComponent/SelectComponent';

function AdministratorMailLogList() {
    const [loading, setLoading] = React.useState(true);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const [searchText, setSearchText] = React.useState('');
    const [statusFilter, setStatusFilter] = React.useState('');
    const [templateFilter, setTemplateFilter] = React.useState('');
    const [dateFrom, setDateFrom] = React.useState('');
    const [dateTo, setDateTo] = React.useState('');
    const isFirstRender = React.useRef(true);
    const [form, setForm] = React.useState({
        searchText: {
            name: "searchText",
            label: "Recherche",
            textHelper: "Filtre sur destinataire/template/erreur.",
            type: "text",
            defaultValue: "",
            options: {},
        },
        statusFilter: {
            name: "statusFilter",
            label: "Statut",
            textHelper: "",
            type: "text",
            defaultValue: "",
            options: {},
        },
        templateFilter: {
            name: "templateFilter",
            label: "Template",
            textHelper: "",
            type: "text",
            defaultValue: "",
            options: {},
        },
        dateFrom: {
            name: "dateFrom",
            label: "Date début",
            textHelper: "Format: YYYY-MM-DD",
            type: "text",
            defaultValue: "",
            options: {},
        },
        dateTo: {
            name: "dateTo",
            label: "Date fin",
            textHelper: "Format: YYYY-MM-DD",
            type: "text",
            defaultValue: "",
            options: {},
        },
    });
    const handlerForm = initFormHandler(form, setForm);
    const statusOptions = [
        { value: '', label: 'Tous' },
        { value: 'sent', label: 'sent' },
        { value: 'failed', label: 'failed' },
        { value: 'skipped', label: 'skipped' },
    ];

    const columns = [
        { name: 'id', label: 'Référence', options: { filter: true, sort: true } },
        { name: 'createdAt', label: 'Date', options: { filter: true, sort: true } },
        { name: 'recipient', label: 'Destinataire', options: { filter: true, sort: true } },
        { name: 'templateId', label: 'Template', options: { filter: true, sort: true } },
        { name: 'status', label: 'Statut', options: { filter: true, sort: true } },
        { name: 'errorMessage', label: 'Erreur', options: { filter: false, sort: false } },
        { name: 'context', label: 'Contexte', options: { filter: false, sort: false } },
    ];

    React.useEffect(() => {
        handlerForm.start();
        setBreadcrumbs({
            title: 'Administrateur',
            context: 'Logs emails',
            description: '',
            links: []
        });
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [handlerForm]);

    React.useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        const timeout = setTimeout(() => {
            dispatch(TableReload('administrator_mail_log_list'));
        }, 200);

        return () => clearTimeout(timeout);
    }, [searchText, statusFilter, templateFilter, dateFrom, dateTo]);

    return (
        <ContentViewComponent loading={loading} breadcrumbs={breadcrumbs}>
            <ShadowBoxComponent style={{ marginBottom: 16 }}>
                <TitleComponent title='Filtres' />
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextFieldComponent
                            id={"searchText"}
                            handler={handlerForm}
                            onChange={(value) => setSearchText(value || '')}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <SelectComponent
                            id={"statusFilter"}
                            handler={handlerForm}
                            options={statusOptions}
                            onChange={(value) => setStatusFilter(value || '')}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextFieldComponent
                            id={"templateFilter"}
                            handler={handlerForm}
                            onChange={(value) => setTemplateFilter(value || '')}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <TextFieldComponent
                            id={"dateFrom"}
                            handler={handlerForm}
                            onChange={(value) => setDateFrom(value || '')}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <TextFieldComponent
                            id={"dateTo"}
                            handler={handlerForm}
                            onChange={(value) => setDateTo(value || '')}
                        />
                    </Grid>
                </Grid>
            </ShadowBoxComponent>
            <TableComponent
                id={'administrator_mail_log_list'}
                title={'Logs emails'}
                mobileMode={'cards'}
                columns={columns}
                search={false}
                promiseServerData={(resolve, options) => {
                    const filters = {
                        limit: options.rowsPerPage,
                        offset: options.page * options.rowsPerPage,
                        sortName: options.sortOrder?.name,
                        sortDirection: options.sortOrder?.direction,
                        searchText: searchText.trim(),
                        status: statusFilter || null,
                        templateId: templateFilter.trim() || null,
                        dateFrom: dateFrom || null,
                        dateTo: dateTo || null,
                    };

                    ApiHandler.get({ route: 'administrator_mail_log_list', data: filters }, (response) => {
                        if (response.status === 200) {
                            const data = (response.data.data || []).map((item) => ({
                                ...item,
                                createdAt: item.createdAt ? moment(item.createdAt).format('LLL') : '-',
                                errorMessage: item.errorMessage || '-',
                                context: item.context || '-',
                            }));
                            resolve(data, response.data.count || 0);
                        } else {
                            resolve([], 0);
                        }
                    });
                }}
            />
        </ContentViewComponent>
    );
}

export default AdministratorMailLogList;
